import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import ExpandableText from '../../../components/ExpandableText/ExpandableText'

const useStyles = makeStyles({
  container: {
    padding: '20px 0',
    maxWidth: 600,
    margin: '0 auto',
  },
})

const FaqTab = () => {
  const translate = useTranslate()
  const classes = useStyles()

  const FAQ_ITEMS = [
    {
      header: translate('ra.text.addingNewUser'),
      text: translate('ra.text.addingNewUserText'),
    },
    {
      header: translate('ra.text.removingUser'),
      text: translate('ra.text.removingUserText'),
    },
    {
      header: translate('ra.text.contactYou'),
      text: translate('ra.text.contactYouText'),
    },
  ]

  return (
    <div className={classes.container}>
      <ExpandableText expandableText={FAQ_ITEMS} allowMultipleExpanded />
    </div>
  )
}

export default FaqTab
